import { render, staticRenderFns } from "./DriverPolicy.vue?vue&type=template&id=42777f53&scoped=true"
import script from "./DriverPolicy.vue?vue&type=script&lang=js"
export * from "./DriverPolicy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42777f53",
  null
  
)

export default component.exports